import type { Terminal } from '../terminal';
import type { Side } from '../../types/game-state';

async function runSideSelect(terminal: Terminal): Promise<Side> {
  await terminal.println('');
  await terminal.println('GLOBAL THERMONUCLEAR WAR', { cssClass: 'bright' });
  await terminal.println('');
  await terminal.pause(500);
  await terminal.println('WHICH SIDE DO YOU WANT?');
  await terminal.println('');
  await terminal.println('  1.  UNITED STATES');
  await terminal.println('  2.  SOVIET UNION');
  await terminal.println('');

  while (true) {
    const input = await terminal.waitForInput('PLEASE CHOOSE ONE: ');
    const upper = input.toUpperCase();

    if (upper === '1' || upper.includes('UNITED') || upper.includes('US') || upper.includes('AMERICA')) {
      await terminal.println('');
      await terminal.println('UNITED STATES SELECTED.', { cssClass: 'bright' });
      await terminal.pause(500);
      return 'US';
    }

    if (upper === '2' || upper.includes('SOVIET') || upper.includes('USSR') || upper.includes('RUSSIA')) {
      await terminal.println('');
      await terminal.println('SOVIET UNION SELECTED.', { cssClass: 'bright' });
      await terminal.pause(500);
      return 'USSR';
    }

    await terminal.println('INVALID SELECTION. CHOOSE 1 OR 2.', { cssClass: 'warning' });
    await terminal.println('');
  }
}

export { runSideSelect };
